async function formImporter() {
	await import("@pressmedia/vuwjbform");
	
	await Promise.all([
		import(/* webpackChunkName: "vuw-form" */ "./VuwFileField.extend"),
		import(/* webpackChunkName: "vuw-form" */ "./VuwParamSet.extend"),
		import(/* webpackChunkName: "vuw-form" */ "./index.scss")
	]);
}

export { formImporter };
